import { useRef } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import Shell from "../../Shell";
import { SidebarPages } from "./config/SidebarPages";
import { lazyComponents } from "./config/LazyComponents";
import MainContainer from "../../components/layout/MainContainer";

const normalizePath = (p: string) => (p.startsWith("/") ? p.slice(1) : p);

const HomePage = lazyComponents.Home;
const NotFoundPage = lazyComponents.NotFound;

const AppRouter = () => {
  const routerRef = useRef<ReturnType<typeof createBrowserRouter>>();
  if (!routerRef.current) {
    routerRef.current = createBrowserRouter(
      createRoutesFromElements(
        <Route path="/" element={<Shell />}>
          <Route
            element={
              <MainContainer>
                <HomePage />
              </MainContainer>
            }
          />
          {SidebarPages.filter(p => p.navigationLocation !== "/").map(p => {
            const Page =
              lazyComponents[p.componentName as keyof typeof lazyComponents];
            return (
              <Route
                key={p.navigationLocation}
                path={normalizePath(p.navigationLocation)}
                element={
                  <MainContainer>
                    <Page />
                  </MainContainer>
                }
              />
            );
          })}
          <Route
            path="*"
            element={
              <MainContainer>
                <NotFoundPage />
              </MainContainer>
            }
          />
        </Route>,
      ),
    );
  }
  return <RouterProvider router={routerRef.current} />;
};

export default AppRouter;
